import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { ReactComponent as PlusIcon } from "../../../assets/plus.svg";
import { ReactComponent as TicketPercentIcon } from "../../../assets/ticket-percent.svg";
import { ReactComponent as TicktesIcon } from "../../../assets/tickets.svg";
import Button from "../../../component/common/Button";
import Input from "../../../component/common/Input";
import SeatingZoomedIn from "./Seating_zoomed_in";
import TicketDesign from "./ticket_design";
import httpServices from "../../../services/httpServices";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../../context/UserContext";


const EventTicket = (setEventId) => {
  const [ticketAllotment, setTicketAllotment] = useState(false);
  const [ticketDesign, setTicketDesign] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null); // For pre-filled data
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { user } = useUser();
  const navigate = useNavigate();
  const [currentTicketId, setCurrentTicketId] = useState(null);

  const fetchTickets = async () => {
    try {
      setLoading(true);
      const response = await httpServices.get(`/eventTicketDetails/by/event/${9}`, {});
      if (!response) {
        throw new Error("Failed to fetch ticket details");
      }
      const data = response.response?.data?.data ?? [];
      setTickets(Array.isArray(data) ? data : [data]);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (ticketId) => {
    try {
      await httpServices.delete(`/eventTicketDetails/delete/${ticketId}`);
      toast.success("Ticket deleted successfully");
      setTickets((prev) => prev.filter((ticket) => ticket.id !== ticketId));
    } catch (err) {
      toast.error("Failed to delete the ticket");
    }
  };

  const handleEdit = async (ticketId) => {
    try {
      const response = await httpServices.get(`/eventTicketDetails/ticket/details/${ticketId}`);

      console.log("-----ticks", ticketId)
      const ticketData = response.response?.data?.data ?? [];
      if (ticketData) {
        setSelectedTicket(ticketData); // Set prefilled data
        setCurrentTicketId(ticketId)
        setOpen(true);

      } else {
        toast.error("Failed to fetch ticket details");
      }
    } catch (err) {
      toast.error("Failed to fetch ticket details");
    }
  };

  const handleNavigateToDesign = (ticketId, eventId) => {
    setTicketDesign(true);
    navigate(`/ticket-design/${ticketId}`, { state: { ticketId, eventId } });
  };

  useEffect(() => {
    fetchTickets();
  }, []);

  return (
    <>
      {ticketDesign && <TicketDesign setTicketDesign={setTicketDesign} />}
      <ResponsiveDialog
        open={open}
        setOpen={setOpen}
        handleClose={() => setOpen(false)}
        fetchTickets={selectedTicket} // Pass ticket data to the dialog
        ticketId={currentTicketId}
      />
      <div>
        <div className="flex justify-between xs:justify-end items-center h-[69px] space-x-0 xs:space-x-4">
          {tickets.length > 0 && (
            <>
              <button
                onClick={() => setTicketAllotment(true)}
                className="outline-purple-btn text-xs xs:text-sm px-3 py-2 font-medium border-blue-color text-blue-color flex gap-2 items-center"
              >
                Ticket Allotment
              </button>
              <button
                onClick={() => setOpen(true)}
                className="outline-purple-btn text-xs xs:text-sm px-[10px] py-2 font-medium border-blue-color text-blue-color flex gap-2 items-center"
              >
                <TicketPercentIcon className="w-3 h-3 xs:w-4 xs:h-4" />
                Create ticket
              </button>
            </>
          )}
        </div>

        <div className="p-3 sm:p-4 max-w-7xl bg-white rounded-[10px] h-[600px]">
          {loading ? (
            <p>Loading tickets...</p>
          ) : error ? (
            <p className="text-red-500">Error: {error}</p>
          ) : tickets.length > 0 ? (
            <div className="w-full overflow-x-auto">
              <table
                className="table-auto border-separate w-full"
                style={{ borderSpacing: "0 10px" }}
              >
                <thead className="table-text">
                  <tr>
                    <th className="p-2">Ticket Type</th>
                    <th className="p-2">Free/Paid</th>
                    <th className="p-2">Price</th>
                    <th className="p-2">Seat Colour</th>
                    <th className="p-2">Seat Allotted</th>
                    <th className="p-2">Ticket Badge</th>
                    <th className="p-2">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {tickets.map((ticket) => (
                    <tr key={ticket.id} className="bg-[#F5F6FA]">
                      <td className="p-2">{ticket.ticketType}</td>
                      <td className="p-2">{ticket.isFree ? "Free" : "Paid"}</td>
                      <td className="p-2">{ticket.ticketPrice ? `${ticket.ticketPrice} AED` : "-"}</td>
                      <td className="p-2">
                        <div
                          style={{
                            backgroundColor: ticket.seatColour,
                            width: "18px",
                            height: "18px",
                            borderRadius: "6px",
                          }}
                        ></div>
                      </td>
                      <td className="p-2">{ticket.seatAllotted}</td>
                      <td className="p-2">
                        <span
                          className="underline text-dark-blue cursor-pointer"
                          onClick={() =>
                            handleNavigateToDesign(ticket.id, 9) // Static eventId
                          }
                        >
                          Edit
                        </span>
                      </td>
                      <td className="p-2">
                        <span
                          className="underline text-dark-blue cursor-pointer"
                          onClick={() => handleEdit(ticket.id)}
                        >
                          Edit
                        </span>{" "}
                        /{" "}
                        <span
                          className="text-[#B80000] cursor-pointer"
                          onClick={() => handleDelete(ticket.id)}
                        >
                          Delete
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="w-full h-full flex flex-col items-center justify-center">
              <TicktesIcon />
              <p className="text-sm text-[#263238] font-medium mt-[22px] mb-[44px]">
                Add Tickets to get started
              </p>
              <button
                onClick={() => setOpen(true)}
                className="btn-gradient py-2 px-4 rounded-md"
              >
                <PlusIcon />
                Create ticket
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );



  function ResponsiveDialog({
    open,
    setOpen,
    handleClose,
    fetchTickets,
    ticketId = null,
    eventId = null,
  }) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  
    const [ticketType, setTicketType] = useState("");
    const [isFree, setIsFree] = useState("");
    const [ticketPrice, setTicketPrice] = useState("");
    const [currencyUnit] = useState("AED"); // Static as per request
    const [seatColour, setSeatColour] = useState("");
  
    const seatColors = [
      { label: "Economical (Purple)", value: "purple", color: "#7020FF" },
      { label: "VIP (Blue)", value: "blue", color: "#0000FF" },
      { label: "Silver (Yellow)", value: "yellow", color: "#FFD700" },
      { label: "Standard (Red)", value: "red", color: "#FF0000" },
    ];
  
    useEffect(() => {
      if (ticketId) {
        console.log("Ticket ID provided:", ticketId);
        const ticket = fetchTickets ?? {};  // make sure fetchTickets is an object
        setTicketType(ticketType || ticket?.ticketType || "");
        setIsFree(isFree || ticket?.isFree ? "true" : "false");
        setTicketPrice(ticket?.ticketPrice || "");
        setSeatColour(ticket?.seatColour || "");
      }
    }, [ticketId, fetchTickets,ticketType,isFree,ticketPrice,seatColour]);  // Ensure this runs on ticketId or fetchTickets change
  
    console.log("TicketType:", ticketType, "IsFree:", isFree, "TicketPrice:", ticketPrice);
  
    const handleSubmit = async () => {
      const payload = {
        ticketType,
        isFree: isFree === "true", // Convert string to boolean
        ticketPrice: isFree === "true" ? 0 : Number(ticketPrice), // Free tickets have 0 price
        currencyUnit,
        seatColour,
        stepDone: 4,
        eventId: eventId || 9, // Use provided eventId or default
      };
  
      try {
        if (ticketId) {
          // Edit existing ticket
          await httpServices.put(`/eventTicketDetails/update/${ticketId}`, payload);
          toast.success("Ticket updated successfully");
        } else {
          // Create new ticket
          await httpServices.post("/eventTicketDetails/create", payload);
          toast.success("Ticket created successfully");
        }
  
        setOpen(false);
        fetchTickets(); // Recall fetchTickets to refresh ticket list
      } catch (error) {
        toast.error("Failed to save ticket");
      }
    };
  
    return (
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        PaperProps={{
          sx: {
            borderRadius: "10px",
            width: { sm: "508px" },
            height: "345px",
          },
        }}
      >
        <DialogTitle id="responsive-dialog-title">
          <h1 className="text-dark-blue font-semibold text-lg">
            {ticketId ? "Edit Ticket" : "Add Ticket"}
          </h1>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-[16px]">
              <Input
                label={"Ticket Type"}
                placeholder={"Enter preferred area"}
                inputClasses="bg-[#F5F6FA] pl-3 rounded-[10px] text-[#06152B]"
                lableClasses="text-[16px]"
                value={ticketType}
                onChange={(e) => {
                  setTicketType(e.target.value);
                  console.log("Ticket Type updated:", e.target.value);  // Log the new value
                }}
              />
              <div>
                <label className="mb-2 text-sm lg:text-[16px] font-medium text-[#06152B]">
                  Free / Paid
                </label>
                <select
                  name="freePaid"
                  id="freePaid"
                  className="pl-3 py-3 bg-[#F5F6FA] w-full rounded-[10px] placeholder:text-500-gray text-sm focus:outline-none"
                  value={isFree}
                  onChange={(e) => {
                    setIsFree(e.target.value);
                    console.log("Free/Paid updated:", e.target.value);  // Log the new value
                  }}
                >
                  <option value="">-- Select --</option>
                  <option value="true">Free</option>
                  <option value="false">Paid</option>
                </select>
              </div>
              <Input
                label={"Price"}
                placeholder={"Enter price"}
                inputClasses="bg-[#F5F6FA] pl-3 rounded-[10px] text-[#06152B]"
                lableClasses="text-[16px]"
                value={ticketPrice}
                onChange={(e) => {
                  setTicketPrice(e.target.value);
                  console.log("Ticket Price updated:", e.target.value);  // Log the new value
                }}
                Icon={() => <span className="text-blue-color text-sm">AED</span>}
                iconClasses="left-[80%]"
                disabled={isFree === "true"} // Disable if ticket is free
              />
              <div>
                <label className="mb-2 text-sm lg:text-[16px] font-medium text-[#06152B]">
                  Seat Colour
                </label>
                <select
                  name="seatColor"
                  id="seatColor"
                  className="pl-3 py-3 bg-[#F5F6FA] w-full rounded-[10px] placeholder:text-500-gray text-sm focus:outline-none"
                  value={seatColour}
                  onChange={(e) => {
                    setSeatColour(e.target.value);
                    console.log("Seat Colour updated:", e.target.value);  // Log the new value
                  }}
                >
                  <option value="">-- Select --</option>
                  {seatColors.map((seat) => (
                    <option
                      key={seat.value}
                      value={seat.value}
                      style={{
                        color: seat.color,
                        fontWeight: "bold",
                      }}
                    >
                      {seat.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="flex justify-center">
              <Button
                content={ticketId ? "Update" : "Add"}
                classes={"py-[9px] px-[77px] mt-[30px] inline-block btn-gradient"}
                onClick={handleSubmit}
              />
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    );
  }
  
};



export default EventTicket;
